import { toast } from "sonner";
import axios from "axios";

// Components
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import DirectorySection from "@/components/DirectorySection";
import ApplicationSection from "@/components/ApplicationSection";
import Footer from "@/components/Footer";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HomePage = ({ hotels, destinations, airlines, stats, loading, onFilterHotels, onFilterDestinations, onFilterAirlines }) => {
  const handleApplicationSubmit = async (formData) => {
    try {
      await axios.post(`${API}/applications`, formData);
      toast.success("Application submitted successfully!", {
        description: "We will review your application and get back to you soon."
      });
      return true;
    } catch (error) {
      console.error("Error submitting application:", error);
      toast.error("Failed to submit application", {
        description: "Please try again later."
      });
      return false;
    }
  };

  return (
    <>
      <Header />
      <main>
        <HeroSection stats={stats} />
        <AboutSection />
        <DirectorySection
          hotels={hotels}
          destinations={destinations}
          airlines={airlines}
          loading={loading}
          onFilterHotels={onFilterHotels}
          onFilterDestinations={onFilterDestinations}
          onFilterAirlines={onFilterAirlines}
        />
        <ApplicationSection onSubmit={handleApplicationSubmit} />
      </main>
      <Footer />
    </>
  );
};

export default HomePage;
